import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "./AssetVerification.css";
import SessionBar from '../Components/SessionBar/SessionBar';
import api from '../services/api';

function AssetVerification({ user }) {
    const navigate = useNavigate();
    const [selectedassets, setSelectedassets] = useState([]);
    const [assets, setAssets] = useState([]);
    const [locations, setLocations] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectAllCommon, setSelectAllCommon] = useState(false);


    const fetchAssets = async () => {
        try {
            const { data } = await api.get(`/user/${user.user_id}`);
            setAssets(Array.isArray(data) ? data : []);
            console.log("Fetched assets:", data);
        } catch (err) {
            if (err.message === 'Session expired') {
                return;
            }
            console.error("error fetching assets:", err);
        }
    };

    const fetchLocations = async () => {
        try {
            const { data } = await api.get('/locations');
            setLocations(Array.isArray(data) ? data : []);
        } catch (err) {
            if (err.message === 'Session expired') {
                return;
            }
            console.error("error fetching locations:", err);
        }
    };

    useEffect(() => {
        fetchAssets();
        fetchLocations();
    }, []);

    const groupAssetsBySubType = (assets) => {
        return assets.reduce((groups, asset) => {
            const subType = asset.asset_sub_type || 'Unknown';
            if (!groups[subType]) {
                groups[subType] = [];
            }
            groups[subType].push(asset);
            return groups;
        }, {});
    };


    const handleSelectAllCommon = (e) => {
        setSelectAllCommon(e.target.checked);
        if (e.target.checked) {
            const unverifiedAssets = assets
                .filter(asset => {
                    const verification = asset.verification || {};
                    const sortedKeys = Object.keys(verification).sort((a, b) => {
                        const numA = parseInt(a.split('_')[1]);
                        const numB = parseInt(b.split('_')[1]);
                        return numA - numB;
                    });
                    const latestKey = sortedKeys[sortedKeys.length - 1];
                    const latestVerification = latestKey ? verification[latestKey] : null;
                    return latestVerification?.accepted !== '+' && latestVerification?.accepted !== '-';
                })
                .map(asset => ({ assetNo: asset.lad_Equip, usedByMe: false, commonPurpose: true }));
            setSelectedassets(unverifiedAssets);
            setSelectAll(false);
        } else {
            setSelectedassets([]);
        }
    };


    const handleSelectAll = (e) => {
        setSelectAll(e.target.checked);
        if (e.target.checked) {
            const unverifiedAssets = assets
                .filter(asset => {
                    const verification = asset.verification || {};
                    const sortedKeys = Object.keys(verification).sort((a, b) => {
                        const numA = parseInt(a.split('_')[1]);
                        const numB = parseInt(b.split('_')[1]);
                        return numA - numB;
                    });
                    const latestKey = sortedKeys[sortedKeys.length - 1];
                    const latestVerification = latestKey ? verification[latestKey] : null;
                    return latestVerification?.accepted !== '+' && latestVerification?.accepted !== '-';
                })
                .map(asset => ({ assetNo: asset.lad_Equip, usedByMe: true, commonPurpose: false }));
            setSelectedassets(unverifiedAssets);
            setSelectAllCommon(false);
        } else {
            setSelectedassets([]);
        }
    };


    const handleCheckboxChange = (assetNo, isVerified, type) => {
        if (isVerified) return;

        setSelectedassets((prev) => {
            const existing = prev.find(a => a.assetNo === assetNo);

            if (type === 'usedByMe') {
                if (existing) {
                    if (existing.usedByMe) {
                        // If already selected, remove from array
                        return prev.filter(a => a.assetNo !== assetNo);
                    } else {
                        // Switch to usedByMe
                        return prev.map(a => a.assetNo === assetNo ? { ...a, usedByMe: true, commonPurpose: false } : a);
                    }
                } else {
                    // Add new with usedByMe selected
                    return [...prev, { assetNo, usedByMe: true, commonPurpose: false }];
                }
            } else {
                if (existing) {
                    if (existing.commonPurpose) {
                        // If already selected, remove from array
                        return prev.filter(a => a.assetNo !== assetNo);
                    } else {
                        // Switch to commonPurpose
                        return prev.map(a => a.assetNo === assetNo ? { ...a, usedByMe: false, commonPurpose: true } : a);
                    }
                } else {
                    // Add new with commonPurpose selected
                    return [...prev, { assetNo, usedByMe: false, commonPurpose: true }];
                }
            }
        });
    };

    const handleAssetClick = async (assetNo) => {
        try {
            // Calculate 50% of screen size
            const screenWidth = window.screen.availWidth;
            const screenHeight = window.screen.availHeight;
            const windowWidth = Math.floor(screenWidth * 0.5);
            const windowHeight = Math.floor(screenHeight * 0.5);
            const left = Math.floor((screenWidth - windowWidth) / 2);
            const top = Math.floor((screenHeight - windowHeight) / 2);

            // Open popup window with asset number in URL
            window.open(
                `/asset-details/${assetNo}`,
                '_blank',
                `width=${windowWidth},height=${windowHeight},left=${left},top=${top},scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,status=no`
            );
        } catch (err) {
            console.error("Error opening asset details:", err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('handleSubmit called');
        console.log('selectedassets:', selectedassets);

        if (selectedassets.length === 0) {
            alert("please select one asset to verify");
            return;
        }

        const division = assets.length > 0 ? assets[0].comp : 'GIL';

        const payload = {
            assets: selectedassets.map(asset => ({
                assetNo: asset.assetNo,
                accepted: asset.usedByMe ? '+' : '-',
                rejected: asset.usedByMe ? '-' : '+',
                comments: ''
            })),
            division: division
        };
        console.log('Sending payload:', payload);
        try {
            const { data } = await api.post('/verify', payload);
            console.log('Verification response:', data);
            if (data.success) {
                const verifiedAssets = selectedassets.map(asset => ({
                    asset_no: asset.assetNo,
                    verified_by: user.user_id,
                    verified_on: new Date().toISOString()
                }));
                sessionStorage.setItem('justVerifiedAssets', JSON.stringify(verifiedAssets));
                alert('Your Asset is verified Successfully');
                setSelectedassets([]);
                setSelectAll(false);
                fetchAssets();
                navigate('/verified-assets');
            } else {
                alert('Verification failed');
            }
        } catch (err) {
            console.error('Full error object:', err);
        console.error('Error response:', err.response?.data);
        console.error('Error status:', err.response?.status);
            if (err.message === 'Session expired') {
                return;
            }
            else {
                console.error("Error verifying assets", err);
                alert('Error verifying assets');
            }

        }
    };

    return (
        <div className="verification-container">
            <SessionBar name='End User Asset Verification and Acceptance' />
            <br /><br />
            <div className="verification-note">
                <ul>
                    <li>Users are requested to verify all the assets which are on their name.</li>
                    <li>Re-check the Assets which are still not verified.</li>
                    <li>Non-Verified Asstes will be removed from network.</li>
                    <li>Email ID on which that Asset is assigned will get blocked.</li>
                </ul>
            </div>

            <p>The assets registered on your name</p>

            <form onSubmit={handleSubmit}>
                {assets.length === 0 ? (
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>Sr. no.</th>
                                <th>Asset no</th>
                                <th>Asset Sub Type</th>
                                <th>
                                    Asset Used by me
                                    <br />
                                    <label style={{ fontWeight: 'normal' }}>
                                        <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                                        Select All
                                    </label>
                                </th>
                                <th>
                                    Asset Used for common purpose
                                    <br />
                                    <label style={{ fontWeight: 'normal' }}>
                                        <input type="checkbox" checked={selectAllCommon} onChange={handleSelectAllCommon} />
                                        Select All
                                    </label>
                                </th>
                                <th>Others</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="6">No assets assigned</td>
                            </tr>
                        </tbody>
                    </table>
                ) : (
                    <table className="styled-table">
                        <thead>
                            <tr>
                                <th>Sr. no.</th>
                                <th>Asset no</th>
                                <th>Asset Sub Type</th>
                                <th>
                                    Asset Used by me
                                    <br />
                                    <label style={{ fontWeight: 'normal' }}>
                                        <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                                        Select All
                                    </label>
                                </th>
                                <th>
                                    Asset Used for common purpose
                                    <br />
                                    <label style={{ fontWeight: 'normal' }}>
                                        <input type="checkbox" checked={selectAllCommon} onChange={handleSelectAllCommon} />
                                        Select All
                                    </label>
                                </th>
                                <th>Others</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(() => {
                                const groupedAssets = groupAssetsBySubType(assets);
                                const subTypes = Object.keys(groupedAssets);
                                let globalIndex = 0;

                                return subTypes.map((subType, groupIndex) => [

                                    globalIndex != 0 ? (
                                        <>
                                            <tr key={`spacer-${subType}`} style={{
                                                height: '20px',
                                                backgroundColor: 'transparent'
                                            }}>
                                                <td colSpan="6" style={{
                                                    border: 'none',
                                                    padding: '0',
                                                    backgroundColor: 'transparent',
                                                    borderTop: 'none',
                                                    borderBottom: 'none'
                                                }}></td>
                                            </tr>
                                            <tr className="tableHead">
                                                <th>Sr. no.</th>
                                                <th>Asset no</th>
                                                <th>Asset Sub Type</th>
                                                <th>
                                                    Asset Used by me
                                                </th>
                                                <th>
                                                    Asset Used for common purpose
                                                </th>
                                                <th>Others</th>
                                            </tr>
                                        </>
                                    ) : "",
                                    ...groupedAssets[subType].map((asset, idx) => {
                                        globalIndex++;
                                        const verification = asset.verification || {};
                                        const sortedKeys = Object.keys(verification).sort((a, b) => {
                                            const numA = parseInt(a.split('_')[1]);
                                            const numB = parseInt(b.split('_')[1]);
                                            return numA - numB;
                                        });
                                        const latestKey = sortedKeys[sortedKeys.length - 1];
                                        const latestVerification = latestKey ? verification[latestKey] : null;
                                        const isVerified = latestVerification?.accepted === '+' || latestVerification?.accepted === '-';
                                        const selected = selectedassets.find(a => a.assetNo === asset.lad_Equip);

                                        return (
                                            <tr key={asset.lad_Equip} className={isVerified ? 'verified-row' : ''}>
                                                <td>{idx + 1}</td>
                                                <td
                                                    style={{ color: '#810055', cursor: 'pointer', textDecoration: 'underline' }}
                                                    onClick={() => handleAssetClick(asset.lad_Equip)}
                                                    title="Click to view asset details"
                                                >
                                                    {asset.lad_Equip}
                                                </td>
                                                <td>{asset.asset_sub_type}</td>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={isVerified ? latestVerification?.accepted === '+' : (selected?.usedByMe || false)}
                                                        onChange={() => handleCheckboxChange(asset.lad_Equip, isVerified, 'usedByMe')}
                                                        disabled={isVerified}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={isVerified ? latestVerification?.accepted === '-' : (selected?.commonPurpose || false)}
                                                        onChange={() => handleCheckboxChange(asset.lad_Equip, isVerified, 'commonPurpose')}
                                                        disabled={isVerified}
                                                    />
                                                </td>
                                                <td>{isVerified ? '' : 'Please check below note and take action accordingly'}</td>
                                            </tr>
                                        );
                                    })
                                ]).flat();
                            })()}
                        </tbody>
                    </table>
                )}
                <button className="submit-btn" type="submit">SUBMIT</button>
            </form>


            <div>
                <table className="styled-table">
                    <thead>
                        <tr style={{ backgroundColor: '#f0f0f0' }}>
                            <th colSpan="4" style={{ textAlign: 'center' }}>Location wise list of ZSA and HO Asset team with Escalation Matrix</th>
                        </tr>
                        <tr>
                            <th>Sr.no.</th>
                            <th>Remote Location</th>
                            <th>Name of OTG Person</th>
                            <th>Email ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {locations.length === 0 ? (
                            <tr>
                                <td colSpan="4">No location data available</td>
                            </tr>
                        ) : (
                            locations.map((loc, idx) => (
                                <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{loc.lcd_location}</td>
                                    <td>{loc.lcd_OTG_Person}</td>
                                    <td>{/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(loc.lcd_emailid || '') ? <a href={`mailto:${loc.lcd_emailid}`}>{loc.lcd_emailid}</a> : <span>{loc.lcd_emailid}</span>}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="note-container">
                <p className="note">
                    <strong>Note:-</strong>
                    <ul>
                        <li>If the assets are physically moved to other place and still is on your name then please fill in <span style={{ color: '#810055', textDecoration: 'underline' }}>"Asset Transfer Internal Revised Form"</span> and transfer to the person who is actually using it.</li>
                        <li>If there are assets which are lying idle then please fill in <span style={{ color: '#810055', textDecoration: 'underline' }}>"Asset Transfer Internal Revised From"</span> and submit to stores. In case of Branch , please speak to Branch Admin or Respective ZSA.</li>
                        <li>If user has moved to other place and using asset which is not on his name, then current owner has to fill <span style={{ color: '#810055', textDecoration: 'underline' }}>"Asset Transfer Internal Revised Form"</span> and need to transfer that asset to self.</li>
                        <li>If in case, you have transferred the asset to store / transferred to emplyoee but it is still showing on your name , then please share the Speedflow number with respective ZSAs for branch and for HO call on Ext 4094/6668.</li>
                        <li>In case of users with multiple assets, Asset Verification summary will be available only after verification of all assets.</li>
                    </ul>
                </p>
            </div>
        </div>
    );
}

export default AssetVerification;
